import { Skeleton } from './Skeleton';
import { skeletonSizes } from '@/design-system/skeleton-tokens';

interface SkeletonDashboardProps {
  /** Number of KPI metric cards */
  kpiCount?: number;
  /** Show bottom chart/table grid */
  showGrid?: boolean;
  className?: string;
}

/**
 * Dashboard skeleton — KPI strip + main content grid.
 * KPI row: 2 cols mobile → 3 cols tablet → 5 cols desktop.
 * Grid: 1 col mobile → 2 cols desktop.
 */
export function SkeletonDashboard({ kpiCount = 5, showGrid = true, className }: SkeletonDashboardProps) {
  return (
    <div className={`space-y-4 ${className ?? ''}`}>
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div className="space-y-1.5">
          <Skeleton className="h-5 w-48" />
          <Skeleton className={`${skeletonSizes.text} w-72`} />
        </div>
        <Skeleton className={`${skeletonSizes.button} w-24 rounded-md`} />
      </div>

      {/* KPI strip */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {Array.from({ length: kpiCount }).map((_, i) => (
          <div key={i} className="p-4 border border-border rounded-lg bg-card space-y-2">
            <Skeleton className={`${skeletonSizes.text} w-16`} />
            <Skeleton className="h-6 w-20" />
            <Skeleton className={`${skeletonSizes.bar} w-12`} />
          </div>
        ))}
      </div>

      {/* Main content grid */}
      {showGrid && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <div className="p-4 border border-border rounded-lg bg-card space-y-3">
            <Skeleton className={`${skeletonSizes.title} w-32`} />
            <Skeleton className={`${skeletonSizes.chart} w-full rounded-md`} />
          </div>
          <div className="p-4 border border-border rounded-lg bg-card space-y-3">
            <Skeleton className={`${skeletonSizes.title} w-32`} />
            <Skeleton className={`${skeletonSizes.chart} w-full rounded-md`} />
          </div>
        </div>
      )}
    </div>
  );
}
